import useSWR from 'swr'

import { IMMUTABLE_SWR_CONFIG } from '../../providers/ApiProvider'
import { selectAllTasksTable } from '../../slices/allTasksTable'
import { useAppSelector } from '../redux'

const usePaginatedFetch = url => {
  const {
    pagination: { page: pageIndex, per_page: pageSize }
  } = useAppSelector(selectAllTasksTable)

  const { data, mutate, isLoading } = useSWR(() => {
    const urlVal = typeof url === 'function' ? url() : url
    if (!urlVal) {
      return null
    }

    return `${urlVal}&page=${pageIndex}&per_page=${pageSize}`
  }, IMMUTABLE_SWR_CONFIG)

  return {
    data,
    pageIndex,
    pageSize,
    loaded: !isLoading,
    enablePagination: true,
    mutate
  }
}

export default usePaginatedFetch
